(() => {
  const copy = {
    'free-delivery': `Free standard shipping on all items to most locations nationwide.
Fast 2–5 days delivery for most items.
We are unable to ship to the following remote areas: Hawaii, Alaska, Puerto Rico, Guam, Virgin Islands, American Samoa, Micronesia, and Marshall Islands.`,
    'secure-checkout': `Card information is secure and uncompromised.
All data is encrypted.
Modernmate never sells your card information.`,
    warranty: 'ModernMate provides 2 years of coverage on all major furniture pieces.',
    'money-back': `Eligible items may be returned within 30 days of the delivery date. Items must meet the following conditions:
Uninstalled and in resalable condition.
Brand new and unused.
All accessories included.`,
    'protected-delivery': `Free Return if Item Damaged.
Replacement if Package Lost.
Multiple shipping options for large items.`,
    'delivery-benefit-4': 'Our customer care team is here to help with questions about this benefit and your order.'
  };

  const init = () => {
    document.querySelectorAll('.product-benefit-drawer').forEach((drawer) => {
      if (drawer.dataset.initialized === 'true') return;
      drawer.dataset.initialized = 'true';
      if (window.Shopify?.designMode || window.self !== window.top) {
        drawer.classList.add('product-benefit-drawer--shopify-preview');
      }
      const section = drawer.closest('product-info');
      const panel = drawer.querySelector('.product-benefit-drawer__panel');
      const title = drawer.querySelector('h2');
      const content = drawer.querySelector('.product-benefit-drawer__content');
      const closeButton = drawer.querySelector('.product-benefit-drawer__close');
      let trigger;

      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('product-benefit-drawer-open');
        trigger?.focus();
      };
      const open = (button) => {
        trigger = button;
        title.textContent = button.dataset.benefitTitle;
        const lines = (copy[button.dataset.benefitKey] || copy['delivery-benefit-4'])
          .split('\n')
          .map((line) => line.trim())
          .filter(Boolean);
        content.replaceChildren();
        if (button.dataset.benefitKey === 'money-back' && lines.length > 1) {
          const introduction = document.createElement('p');
          introduction.textContent = lines.shift();
          content.appendChild(introduction);
        }
        const list = document.createElement('ul');
        lines.forEach((line) => {
          const item = document.createElement('li');
          item.textContent = line;
          list.appendChild(item);
        });
        content.appendChild(list);
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('product-benefit-drawer-open');
        closeButton.focus();
      };

      section?.querySelectorAll('.product__delivery-benefit').forEach((button) => {
        button.addEventListener('click', () => open(button));
      });
      drawer.querySelector('.product-benefit-drawer__overlay')?.addEventListener('click', close);
      closeButton?.addEventListener('click', close);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
